import bridgeV1 from './androidV1'
import bridgeV2 from './androidV2'

const bridge = {
  ...bridgeV1,
  ...bridgeV2
}

export default bridge
